import {
  type HtmlToSlateConfig,
  htmlToSlateConfig,
} from '@slate-serializers/html';

import type { CustomTextKey } from './EditorTextArea.types';

export const MAX_INDENT_LEVEL = 8;

export const INITIAL_VALUE = [
  {
    type: 'paragraph',
    children: [{ text: '' }],
  },
];

export const HOTKEYS: Record<string, CustomTextKey> = {
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+u': 'underline',
  'mod+`': 'code',
};

export const LIST_TYPES = ['ul', 'ol'] as const;

export const TEXT_ALIGN_TYPES = ['left', 'center', 'right', 'justify'] as const;

export const HTML_TO_SLATE_CONFIG: HtmlToSlateConfig = {
  ...htmlToSlateConfig,
  textTags: {
    ...htmlToSlateConfig.textTags,
    ins: () => ({ underline: true }),
  },
  filterWhitespaceNodes: true,
};

export const SANITIZE_OPTIONS = {
  ALLOWED_TAGS: ['a', 'br', 'em', 'li', 'ol', 'p', 'span', 'strong', 'ul'],
  ALLOWED_ATTR: [],
};
